import { useTranslation } from 'react-i18next'

import { FormatNumber, Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const OptionFilter = ({ option, isActive, total, onChange }) => {
  const { t } = useTranslation()

  const { label, Icon, iconColor } = option

  const handleClick = () => onChange(option.value)

  return (
    <Styles.Container active={isActive} onClick={handleClick}>
      {Icon && <Icon size={20} weight="regular" color={iconColor} />}
      <Text type="bodyMMedium">{t(label)}</Text>
      <Text type="bodyMMedium">
        <FormatNumber style="decimal">{total}</FormatNumber>
      </Text>
    </Styles.Container>
  )
}

export default OptionFilter
